import './RoundBalls.scss';
import { Ball } from '../../platform/components/ball/Ball';
import { observer } from 'mobx-react';
import { roundStore } from '../../platform/stores';

export const RoundBalls = observer(() => {
  const { openedNumbers } = roundStore;

  return (
    <div className="round-balls-components">
      <div className="balls-count">
        {openedNumbers.length}<span>/20</span>
      </div>
      <div className="box">
        <div className="mini-box">
        <div className="balls">
            <div className="balls">
              {
                openedNumbers.map((item) =>
                  <div className="ball-item" key={'round-balls-' + item}>
                    <Ball number={item}/>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
